export enum CurrencySymbolSpacing {
    None = 'None',
    Single = 'Single',
}
